"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
class Pivx extends base_1.default {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor({ network }) {
        super({ network });
        // refer to https://github.com/LedgerHQ/lib-ledger-core/blob/master/core/src/wallet/bitcoin/networks.cpp#L369
        this.network.bip32.public = 0x022d2533;
        this.network.pubKeyHash = 0x1e;
        this.network.scriptHash = 0x0d;
        this.network.dustThreshold = 10000;
        this.network.dustPolicy = "FIXED";
        this.network.usesTimestampedTransaction = false;
    }
}
exports.default = Pivx;
//# sourceMappingURL=pivx.js.map